import { initializeApp } from 'firebase/app';
import { getAuth,  } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: 'AIzaSyCeqV4cYDiApCZ_2-3WKkvznXZ0hNrhbFA',
  authDomain: 'br-com-bmenu.firebaseapp.com',
  projectId: 'br-com-bmenu',
  storageBucket: 'br-com-bmenu.firebasestorage.app',
  messagingSenderId: '1033017312447',
  appId: '1:1033017312447:web:f0d1022e4d674e73a2320a',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app)
